const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/notify.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/notify.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AppNotifyListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/notify-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/notify')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: AppNotifyListFilterParamSchema,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});